import { useState } from 'react';
import { PresenceUser } from '@/providers/CollaborationProvider';

interface PresenceAvatarsProps {
  users: PresenceUser[];
}

const MAX_VISIBLE = 5;

export function PresenceAvatars({ users }: PresenceAvatarsProps) {
  const visible = users.slice(0, MAX_VISIBLE);
  const overflow = users.length - MAX_VISIBLE;

  return (
    <div className="flex items-center -space-x-2">
      {visible.map((user) => (
        <Avatar key={user.id} user={user} />
      ))}
      {overflow > 0 && (
        <div className="relative z-0 flex h-8 w-8 items-center justify-center rounded-full bg-gray-200 text-xs font-medium text-gray-600 ring-2 ring-white">
          +{overflow}
        </div>
      )}
    </div>
  );
}

function Avatar({ user }: { user: PresenceUser }) {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div
      className="relative z-10"
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      {showTooltip && (
        <div className="absolute -top-8 left-1/2 -translate-x-1/2 whitespace-nowrap rounded bg-gray-900 px-2 py-1 text-xs text-white shadow-lg">
          {user.displayName}
        </div>
      )}
      {user.avatarUrl ? (
        <img
          src={user.avatarUrl}
          alt={user.displayName}
          className="h-8 w-8 rounded-full object-cover ring-2"
          style={{ borderColor: user.color, boxShadow: `0 0 0 2px ${user.color}` }}
        />
      ) : (
        <div
          className="flex h-8 w-8 items-center justify-center rounded-full text-xs font-semibold text-white ring-2 ring-white"
          style={{ backgroundColor: user.color }}
        >
          {user.displayName.charAt(0).toUpperCase()}
        </div>
      )}
    </div>
  );
}
